var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCertificate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {
    display: "block"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#726855",
  d: "M10 10.625a.625.625 0 0 1-.625.625h-3.75a.625.625 0 1 1 0-1.25h3.75a.625.625 0 0 1 .625.625M9.375 7.5h-3.75a.625.625 0 0 0 0 1.25h3.75a.625.625 0 0 0 0-1.25m8.75 5.115V17.5a.625.625 0 0 1-.937.547l-1.875-1.074-1.876 1.074a.624.624 0 0 1-.937-.547v-1.875H3.125a1.25 1.25 0 0 1-1.25-1.25v-10a1.25 1.25 0 0 1 1.25-1.25h13.75a1.25 1.25 0 0 1 1.25 1.25V6.76a4.053 4.053 0 0 1 0 5.855m-5.625 1.76v-1.76a4.062 4.062 0 0 1 4.375-6.677V4.375H3.125v10zm4.375-.937a4.05 4.05 0 0 1-3.125 0v2.985l1.25-.715a.63.63 0 0 1 .62 0l1.25.715zm1.25-3.75a2.812 2.812 0 1 0-5.624 0 2.812 2.812 0 0 0 5.624 0"
})));
export default SvgCertificate;